import { render, staticRenderFns } from "./addCommodity.vue?vue&type=template&id=0944e096&scoped=true&"
import script from "./addCommodity.vue?vue&type=script&lang=js&"
export * from "./addCommodity.vue?vue&type=script&lang=js&"
import style0 from "./addCommodity.vue?vue&type=style&index=0&lang=css&"
import style1 from "./addCommodity.vue?vue&type=style&index=1&id=0944e096&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0944e096",
  null
  
)

export default component.exports